exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{canvas#horizontalbar-chart{width:100%!important}}", ""]);

// exports
